import { z } from "zod";

/** URL-safe slug: lowercase alphanumeric words separated by single hyphens. */
export const slugSchema = z
  .string()
  .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, "must be a lowercase hyphen-separated slug")
  .max(120);

/**
 * Top-level path prefixes owned by the infrastructure (storefront + media +
 * JSON API). A content type may not take one of these as its slug, or its
 * listing page would collide with a reserved route.
 */
export const RESERVED_SLUGS: readonly string[] = ["products", "api", "media", "homepage-assets"];

/** Convert arbitrary text into a safe slug. */
export function slugify(input: string): string {
  const out = input
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 120);
  return out.length > 0 ? out : "untitled";
}
